(function() {
  const openPopupBtns = document.querySelectorAll('.blog__download-checklist');
  const closePopupBtns = document.querySelectorAll('.newsletter-popup__dismiss-icon');
  const popupEl = document.querySelector('.newsletter-popup');
  const popupWrapperEl = document.getElementById('download-checklist');
  const popupFormEl = document.getElementById('article-subscribe');
  const downloadChecklistEl = document.getElementById('download-checklist-button');

  function showScrollOnPage(popupEl) {
    popupEl.classList.remove('newsletter-popup--active');
    document.body.style.overflow = '';
  }

  if (popupWrapperEl) {
    openPopupBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        popupWrapperEl.classList.add('newsletter-popup--active');
        document.body.style.overflow = 'hidden';
      });
    });

    closePopupBtns.forEach((btn) => {
      btn.addEventListener('click', () => {
        showScrollOnPage(popupWrapperEl);
      });
    });

    if (popupEl) {
      popupWrapperEl.addEventListener('click', (e) => {
        const withinBoundaries = e.composedPath().includes(popupEl);
       
        if (!withinBoundaries) {
          showScrollOnPage(popupWrapperEl);
        }
      });
    }
  }

  if (popupFormEl && downloadChecklistEl) {
    popupFormEl.addEventListener('submit', () => {
      downloadChecklistEl.click();
    });
  }
})();
